import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { websocketActionsWorkspaces } from '@/common/context/websocketActions/constants'
import useWebsocketActions from '@/common/hooks/useWebsocketActions/useWebsocketActions'

import { pendingWebsocketActionTypes } from '../useWebsocketTransactionAction/constants'

const useIssueRefundDrawer = ({ setToastInfo, handleChargebackError }) => {
  const { t } = useTranslation()
  const [showIssueRefundDrawer, setShowIssueRefundDrawer] = useState(false)

  const { setPendingWebsocketAction } = useWebsocketActions(websocketActionsWorkspaces.transactions)

  const openIssueRefundDrawer = () => {
    setShowIssueRefundDrawer(true)
  }

  const closeIssueRefundDrawer = () => {
    setShowIssueRefundDrawer(false)
  }

  const handleRefundIssued = response => {
    closeIssueRefundDrawer()
    setToastInfo({ show: true, message: t('Reembolso emitido correctamente'), type: 'success' })
    setPendingWebsocketAction(pendingWebsocketActionTypes.issueRefund, response)
  }

  const handleIssueRefundError = error => {
    closeIssueRefundDrawer()

    if (handleChargebackError(error)) return

    setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
  }

  return {
    showIssueRefundDrawer,
    openIssueRefundDrawer,
    closeIssueRefundDrawer,
    handleRefundIssued,
    handleIssueRefundError,
  }
}

export default useIssueRefundDrawer
